<!--
 * @Author: chengleilei
 * @Date: 2025-09-25 09:52:28
 * @Description: 非轮订单
-->
<template>
    <div>
        <PageHeader title="订单列表" hidden-breadcrumb />
        <div class="order-list">
            <Tabs :value="current" :animated="true" @on-click="handleTabClick">
                <TabPane label="全部" name="all">
                    <all ref="all" />
                </TabPane>
                <TabPane label="待付款" name="pendpay">
                    <pendpay ref="pendpay" />
                </TabPane>
                <TabPane label="待发货" name="wait">
                    <wait ref="wait" />
                </TabPane>
                <TabPane label="已发货" name="send">
                    <send ref="send" />
                </TabPane>
                <TabPane label="已关闭" name="close">
                    <close ref="close" />
                </TabPane>
                <TabPane label="已取消" name="cancel">
                    <cancel ref="cancel" />
                </TabPane>
                <TabPane label="已退款" name="refund">
                    <refund ref="refund" />
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>
<script>
import all from './all';
import pendpay from './pendpay';
import wait from './wait';
import send from './send';
import close from './close';
import cancel from './cancel';
import refund from './refund';
import { apiBrandingCompanyList } from '@/api/purchase';

export default {
    components: { all, pendpay, wait, send, close, cancel, refund },
    data() {
        return {
            current: 'wait',
        };
    },
    mounted() {
        this.getCorrelationCompany();
    },
    methods: {
        // 获取品牌商列表（关联的）
        async getCorrelationCompany() {
            const res = await apiBrandingCompanyList();
            this.$refs['all'].renderOptions(res);
            this.$refs['pendpay'].renderOptions(res);
            this.$refs['wait'].renderOptions(res);
            this.$refs['send'].renderOptions(res);
            this.$refs['close'].renderOptions(res);
            this.$refs['cancel'].renderOptions(res);
            this.$refs['refund'].renderOptions(res);
        },

        handleTabClick(e) {
            if (e === this.current) {
                return false;
            }
            this.current = e;
            this.$refs[e].getData();
        },
    },
};
</script>
<style lang="less">
.order-list {
    .ivu-tabs-nav-scroll {
        background: #fff;
        padding: 13px 15px;
    }
}
</style>
